import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import IshitaProfile from "../../../../src/collections/blog/2020/2020-07-03-my-meshy-journey/ishita-kumar-profile.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  IshitaProfile,
  React
};